/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendChangePasswordDto } from '../../models/backend-change-password-dto';
import { BackendChangePasswordRequestDto } from '../../models/backend-change-password-request-dto';

export interface AccountMeChangePasswordUpdate$Params {
  body: BackendChangePasswordRequestDto;
}

export function accountMeChangePasswordUpdate(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeChangePasswordUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendChangePasswordDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeChangePasswordUpdate.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendChangePasswordDto>;
    }),
  );
}

accountMeChangePasswordUpdate.PATH = '/api/account/me/change_password/';
